import React from "react";
import "./Footer.scss";
const Footer = () => {
  return (
    <div className="footer">
      <div className="top">
        <div className="item">
          <h1>Categories</h1>
          <span>Women</span>
          <span>Men</span>
          <span>Children</span>
          <span>Shoes</span>
          <span>Accessories</span>
          <span>New Arrivals</span>
        </div>
        <div className="item">
          <h1>Links</h1>
          <span>FAQ</span>
          <span>Pages</span>
          <span>Stores</span>
          <span>Compare</span>
          <span>Cookies</span>
        </div>
        <div className="item">
          <h1>About</h1>
          {/* <span>Contact</span>
          <span>About</span>
          <span>Careers</span>
          <span>Affiliates</span> */}
          <span>Lorem ipsum dolor sit amet consectetur adipisicing elit. Perspiciatis porro repellendus, error accusamus facere unde vitae voluptatibus, reprehenderit quis enim praesentium adipisci velit nihil iusto nulla, sapiente cum fugit commodi!</span>
        </div>
        <div className="item">
          <h1>Contact</h1>
          <span>IENAGA & CO, 1234 Street Name, City, Country</span>
          <span>Lorem ipsum dolor sit amet consectetur, adipisicing elit. Quam laudantium, porro beatae excepturi blanditiis placeat rem sed ex nihil! Est ab quidem, inventore ratione eaque ea natus? Accusantium, non error!</span>
        </div>
      </div>
      <div className="bottom">
        <div className="left">
          <span className="logo">IENAGA & CO</span>
          <span className="copyright">© All Rights Reserved</span>
        </div>
        <div className="right">
          <img src="/img/payment.png" alt="" />
        </div>
      </div>
    </div>
  );
};

export default Footer;
